import styled_components from "styled-components";
import { Input, Select, Tooltip } from "pcln-design-system";
import { Check, Success, Warning } from "pcln-icons";
const FormInput = /*#__PURE__*/ styled_components(Input).withConfig({
    displayName: "OtpForm.styles__FormInput"
})([
    "background:#fff;"
]);
const ErrorToolTip = /*#__PURE__*/ styled_components(Tooltip).withConfig({
    displayName: "OtpForm.styles__ErrorToolTip"
})([
    "z-index:100;margin-top:2px;"
]);
const CheckIcon = /*#__PURE__*/ styled_components(Check).withConfig({
    displayName: "OtpForm.styles__CheckIcon"
})([
    "z-index:100;"
]);
const WarningIcon = /*#__PURE__*/ styled_components(Warning).withConfig({
    displayName: "OtpForm.styles__WarningIcon"
})([
    "z-index:100;"
]);
const SuccessIcon = /*#__PURE__*/ styled_components(Success).withConfig({
    displayName: "OtpForm.styles__SuccessIcon"
})([
    "z-index:100;"
]);
const SelectInput = /*#__PURE__*/ styled_components(Select).withConfig({
    displayName: "OtpForm.styles__SelectInput"
})([
    "background:#fff;"
]);
export { CheckIcon, ErrorToolTip, FormInput, SelectInput, SuccessIcon, WarningIcon };
